// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"12dce2f3","453":"c06ab884","455":"aa826d84","977":"f3f558d2"}[chunkId] + ".chunk.js";
};